import React from "react";
import { Link } from "react-router-dom";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import "./wishList.css";

function AuthenticatedPage() {
  return (
    <main className="wishlist-page">
      <div
        style={{
          maxWidth: "600px",
          margin: "60px auto",
          padding: "48px 32px",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
          textAlign: "center",
          border: "1px solid #e8e1d7",
        }}
      >
        <div
          style={{
            width: "68px",
            height: "68px",
            borderRadius: "50%",
            background: "#fef3f2",
            color: "#e11d48",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <FavoriteBorderIcon style={{ fontSize: "36px" }} />
        </div>

        <h2
          style={{
            fontSize: "26px",
            fontWeight: 900,
            color: "#111827",
            marginBottom: "12px",
          }}
        >
          Save Products You Love
        </h2>

        <p
          style={{
            fontSize: "15px",
            lineHeight: 1.6,
            color: "#4b5563",
            marginBottom: "28px",
            maxWidth: "460px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Sign in or create an account to save your favorite items, get notified of price drops,
          and sync your wishlist across all your devices.
        </p>

        <div
          style={{
            display: "flex",
            gap: "14px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/Login?redirect=%2FWishList"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 28px",
              background: "#111111",
              color: "#ffffff",
              borderRadius: "8px",
              fontWeight: 800,
              fontSize: "14px",
              textDecoration: "none",
              transition: "opacity 0.2s",
            }}
          >
            <LockOutlinedIcon fontSize="small" /> Sign In
          </Link>

          <Link
            to="/Signin"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "12px 28px",
              background: "#ffffff",
              color: "#111111",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              fontWeight: 800,
              fontSize: "14px",
              textDecoration: "none",
              transition: "background 0.2s",
            }}
          >
            <PersonAddOutlinedIcon fontSize="small" /> Create Account
          </Link>
        </div>
      </div>
    </main>
  );
}

export default AuthenticatedPage;